
import { useTranslation } from 'react-i18next';
import { LuUsers } from "react-icons/lu";
import { CiLocationOn } from "react-icons/ci";
import { BsArchive } from "react-icons/bs";
import { GoInbox } from "react-icons/go";
import { CgLogIn } from "react-icons/cg";
import { FaRegClock } from "react-icons/fa";


const Statistics = ({statics}) => {
  const {t} =useTranslation()
  return (
    <div className="container-fluid">
    <div className="row">
    <div class="col-sm-6 col-xl-4">
      <div class="ecommerce-widget pro-gress card">
        <div class="support-ticket-font card-body">
          <div class="row">
            <div class="col-12">
              <h6>{t("Employes")}</h6>
              <h4 class="total-num counter"><span>{statics.employes}</span></h4>
            </div>
            </div>
            <div class="progress-showcase mt-3">
              <div class="progress">
                <div class="progress-bar bg-info" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: "25%"}}></div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-4">
      <div class="ecommerce-widget pro-gress card">
        <div class="support-ticket-font card-body">
          <div class="row">
            <div class="col-5">
              <h6>{t("Checkin")}</h6>
              <h4 class="total-num counter"><span>{statics.attendances}</span></h4>
            </div>
            <div class="col-7">
              <div class="text-md-end">
                <ul class="simple-list list-group">
                  <li class="list-group-item"><span class="product-stts txt-primary ms-2">{statics.attendancesProfit}<i class="icon-angle-up f-12 ms-1"></i></span></li>
                  <li class="list-group-item"><span class="product-stts txt-danger ms-2">{statics.attendancesLoss}<i class="icon-angle-down f-12 ms-1"></i></span></li>
                </ul>
              </div>
            </div>
            </div>

            <div class="progress-showcase mt-3">
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: statics.attendancesProgress}}></div>
              </div>
            </div>
        </div>
      </div>
    </div> 
    <div class="col-sm-6 col-xl-4">
      <div class="ecommerce-widget pro-gress card">
        <div class="support-ticket-font card-body">
          <div class="row">
            <div class="col-5">
              <h6>{t("Checkout")}</h6>
              <h4 class="total-num counter"><span>{statics.outs}</span></h4>
            </div>
            <div class="col-7">
              <div class="text-md-end">
                <ul class="simple-list list-group">
                  <li class="list-group-item"><span class="product-stts txt-primary ms-2">{statics.outsProfit}<i class="icon-angle-up f-12 ms-1"></i></span></li>
                  <li class="list-group-item"><span class="product-stts txt-danger ms-2">{statics.outsLoss}<i class="icon-angle-down f-12 ms-1"></i></span></li>
                </ul>
              </div>
            </div>
            </div>
            <div class="progress-showcase mt-3">
              <div class="progress">
                <div class="progress-bar bg-secondary" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: statics.outsProgress}}></div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-4">
      <div class="ecommerce-widget pro-gress card">
        <div class="support-ticket-font card-body">
          <div class="row">
            <div class="col-5">  
              <h6>{t("Late Check In")}</h6>
              <h4 class="total-num counter"><span>{statics.lates}</span></h4>
            </div>
            <div class="col-7">
              <div class="text-md-end">
                <ul class="simple-list list-group">
                  <li class="list-group-item"><span class="product-stts txt-primary ms-2">{statics.latesProfit}<i class="icon-angle-up f-12 ms-1"></i></span></li>
                  <li class="list-group-item"><span class="product-stts txt-danger ms-2">{statics.latesLoss}<i class="icon-angle-down f-12 ms-1"></i></span></li>
                </ul>
              </div>
            </div>
            </div>
            <div class="progress-showcase mt-3">
              <div class="progress">
                <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: statics.latesProgress}}></div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-4">
      <div class="ecommerce-widget pro-gress card">
        <div class="support-ticket-font card-body">
          <div class="row">
            <div class="col-5">
              <h6>{t("Early Checkout")}</h6>
              <h4 class="total-num counter"><span>{statics.early_outs}</span></h4>
            </div>
            <div class="col-7">
              <div class="text-md-end">
                <ul class="simple-list list-group">
                  <li class="list-group-item"><span class="product-stts txt-primary ms-2">{statics.early_outsProfit}<i class="icon-angle-up f-12 ms-1"></i></span></li>
                  <li class="list-group-item"><span class="product-stts txt-danger ms-2">{statics.early_outsLoss}<i class="icon-angle-down f-12 ms-1"></i></span></li>
                </ul>
              </div>
            </div>
            </div>
            <div class="progress-showcase mt-3">
              <div class="progress">
                <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: statics.early_outsProgress}}></div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-4">
      <div class="ecommerce-widget pro-gress card">
        <div class="support-ticket-font card-body">
          <div class="row">
            <div class="col-5">
              <h6>{t("Absent")}</h6>
              <h4 class="total-num counter"><span>{statics.absences}</span></h4>
            </div>
            <div class="col-7">
              <div class="text-md-end">
                <ul class="simple-list list-group">
                  <li class="list-group-item"><span class="product-stts txt-primary ms-2">{statics.absencesProfit}<i class="icon-angle-up f-12 ms-1"></i></span></li>
                  <li class="list-group-item"><span class="product-stts txt-danger ms-2">{statics.absencesLoss}<i class="icon-angle-down f-12 ms-1"></i></span></li>
                </ul>
              </div>
            </div>
            </div>
            <div class="progress-showcase mt-3">
              <div class="progress">
                <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: statics.absencesProgress}}></div>
              </div>
            </div>
        </div>
      </div>
    </div>



    </div>
  </div>
  )
}

export default Statistics